import * as React from "react";

function SvgIcShow(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.14 11.915C6.55 14.095 8.443 17 12 17c3.557 0 5.449-2.904 6.86-5.085-.476-.947-1.319-2.187-2.485-3.184C15.198 7.725 13.735 7 12 7c-1.736 0-3.198.725-4.375 1.731-1.166.997-2.01 2.237-2.485 3.184zm1.185-4.704C7.761 5.984 9.668 5 12 5s4.239.984 5.674 2.211c1.429 1.22 2.433 2.716 3 3.86a1.942 1.942 0 01-.127 1.92l-.115.178C19.106 15.222 16.668 19 12 19c-4.668 0-7.106-3.777-8.432-5.831l-.115-.178a1.942 1.942 0 01-.127-1.92c.567-1.144 1.571-2.64 3-3.86z"
        fill="currentColor"
      />
      <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" fill="currentColor" />
    </svg>
  );
}

export default SvgIcShow;
